import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

import {
  collection,
  query,
  where,
  onSnapshot,
  doc,
  updateDoc,
  deleteDoc,
  addDoc,
  serverTimestamp,
  FieldPath,
} from "firebase/firestore";

import {
  FaCar,
  FaStore,
  FaBoxOpen,
  FaShoppingCart,
  FaNewspaper,
  FaMapMarkerAlt,
  FaUsers,
  FaUserCheck,
  FaChevronRight,
  FaClipboardList,
  FaChartBar,
  FaEdit,
} from "react-icons/fa";

import { db, creditWallet } from "../firebase";
import "../styles/Admin.css";

const ADMIN_UID = "jKahzGJWb2hRmWWrppjWCiazpFd2";

export default function Admin() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

 const [drivers, setDrivers] = useState([]);
const [approvedDrivers, setApprovedDrivers] = useState([]);

/* DELIVERY PERSONS */
const [deliveryPersons, setDeliveryPersons] = useState([]);
const [approvedDeliveryPersons, setApprovedDeliveryPersons] = useState([]);

const [shops, setShops] = useState([]);
const [volunteerSubmissions, setVolunteerSubmissions] = useState([]);

const [activeSection, setActiveSection] = useState(null);
const [shopFilter, setShopFilter] = useState("premium");

const [editingShop, setEditingShop] = useState(null);
const [savingShop, setSavingShop] = useState(false);

  useEffect(() => {
    if (!user) {
      navigate("/login");
      return;
    }

    if (user.uid !== ADMIN_UID) {
      alert("Access Denied");
      navigate("/");
      return;
    }

    setIsAdmin(true);

    const unsubscribePending = loadPendingDrivers();
const unsubscribeApproved = loadApprovedDrivers();

const unsubscribeDeliveryPending =
  loadPendingDeliveryPersons();

const unsubscribeDeliveryApproved =
  loadApprovedDeliveryPersons();

const unsubscribeShops = loadShops();
const unsubscribeVolunteers = loadVolunteerSubmissions();

return () => {
  unsubscribePending && unsubscribePending();
  unsubscribeApproved && unsubscribeApproved();

  unsubscribeDeliveryPending &&
    unsubscribeDeliveryPending();

  unsubscribeDeliveryApproved &&
    unsubscribeDeliveryApproved();

  unsubscribeShops && unsubscribeShops();
  unsubscribeVolunteers && unsubscribeVolunteers();
};

return () => {
  unsubscribePending && unsubscribePending();
  unsubscribeApproved && unsubscribeApproved();
  unsubscribeShops && unsubscribeShops();
  unsubscribeVolunteers && unsubscribeVolunteers();
};
  }, [user, navigate]);

  function loadPendingDrivers() {
    const q = query(
      collection(db, "autos"),
      where("verified", "==", false)
    );

    return onSnapshot(
      q,
      (snap) => {
        setDrivers(
          snap.docs.map((d) => ({
            id: d.id,
            ...d.data(),
          }))
        );

        setLoading(false);
      },
      (err) => {
        console.error(err);
        setLoading(false);
      }
    );
  }

  function loadApprovedDrivers() {
  const q = query(
    collection(db, "autos"),
    where("verified", "==", true)
  );

  return onSnapshot(
    q,
    (snap) => {
      setApprovedDrivers(
        snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }))
      );
    },
    (err) => {
      console.error("Approved drivers error:", err);
    }
  );
}

/* =========================================================
   DELIVERY PERSONS
========================================================= */

function loadPendingDeliveryPersons() {
  const q = query(
    collection(db, "deliveryPersons"),
    where("applicationStatus", "==", "PENDING")
  );

  return onSnapshot(
    q,
    (snap) => {
      setDeliveryPersons(
        snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }))
      );
    },
    (err) => {
      console.error(
        "Pending delivery persons error:",
        err
      );
    }
  );
}

function loadApprovedDeliveryPersons() {
  const q = query(
    collection(db, "deliveryPersons"),
    where("applicationStatus", "==", "APPROVED")
  );

  return onSnapshot(
    q,
    (snap) => {
      setApprovedDeliveryPersons(
        snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }))
      );
    },
    (err) => {
      console.error(
        "Approved delivery persons error:",
        err
      );
    }
  );
}

async function approveDeliveryPerson(uid) {
  if (!uid) return;

  const person = deliveryPersons.find(
    (item) => item.id === uid
  );

  if (
    !window.confirm(
      `Approve "${person?.name || "this delivery person"}"?`
    )
  ) {
    return;
  }

  try {
    await updateDoc(
      doc(db, "deliveryPersons", uid),
      {
        verified: true,
        applicationStatus: "APPROVED",

        /*
         * New approved delivery persons
         * start as unavailable.
         */
        available: false,

        lastCheckIn: null,
        availabilityExpiresAt: null,

        currentOrderId: "",

        approvedAt: serverTimestamp(),
        approvedBy: user?.uid || "",

        updatedAt: serverTimestamp(),
      }
    );

    alert(
      "✅ Delivery person approved successfully."
    );
  } catch (err) {
    console.error(
      "Delivery person approval failed:",
      err
    );

    alert(
      "Failed to approve delivery person."
    );
  }
}


async function rejectDeliveryPerson(uid) {
  if (!uid) return;

  const person = deliveryPersons.find(
    (item) => item.id === uid
  );

  if (
    !window.confirm(
      `Reject "${person?.name || "this application"}"?`
    )
  ) {
    return;
  }

  try {
    await updateDoc(
      doc(db, "deliveryPersons", uid),
      {
        verified: false,
        applicationStatus: "REJECTED",

        available: false,
        lastCheckIn: null,
        availabilityExpiresAt: null,

        rejectedAt: serverTimestamp(),
        rejectedBy: user?.uid || "",

        updatedAt: serverTimestamp(),
      }
    );

    alert(
      "❌ Delivery person application rejected."
    );
  } catch (err) {
    console.error(
      "Delivery person rejection failed:",
      err
    );

    alert(
      "Failed to reject delivery person."
    );
  }
}

function loadShops() {
  const q = collection(db, "shops");

  return onSnapshot(
    q,
    (snap) => {
      const shopData = snap.docs.map((d) => {
        const data = d.data();

        return {
          id: d.id,
          ...data,

          // Handle both field names used in Firestore
          shopType:
            data["Type (Premium/Normal)"] ||
            data.Type ||
            "Normal",

          shopName:
            data["Shop Name"] ||
            data.shopName ||
            "Unnamed Shop",

          shopImage:
            data["Shop Image"] ||
            data.shopImage ||
            "",

          location:
            data.Location ||
            data.location ||
            "",

          mobile:
            data["Mobile Number"] ||
            data.mobile ||
            "",

          category:
            data.Category ||
            data.category ||
            "",

          productCount:
            data.productCount || 0,

          shares:
            data.Shares || 0,
        };
      });

      setShops(shopData);
    },
    (err) => {
      console.error("Shops error:", err);
    }
  );
}

function loadVolunteerSubmissions() {
  const q = query(
    collection(db, "businessSubmissions"),
    where("status", "==", "PENDING_REVIEW")
  );

  return onSnapshot(
    q,
    (snap) => {
      setVolunteerSubmissions(
        snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }))
      );
    },
    (err) => {
      console.error(
        "Volunteer submissions error:",
        err
      );
    }
  );
}


async function saveShopType() {
  if (!editingShop?.id) return;

  try {
    setSavingShop(true);

    const shopRef = doc(db, "shops", editingShop.id);

    const newShopType = editingShop.shopType;

    // Use FieldPath for the existing field name
    // because it contains a slash (/).
    await updateDoc(
      shopRef,

      new FieldPath("Type (Premium/Normal)"),
      newShopType,

      "Type",
      newShopType,

      "updatedAt",
      serverTimestamp(),

      "updatedBy",
      user?.uid || ""
    );

    alert(
      `✅ Shop type updated successfully!\n\n` +
      `Shop: ${editingShop.shopName}\n` +
      `Type: ${newShopType}`
    );

    setEditingShop(null);

  } catch (err) {
    console.error("❌ Failed to update shop type:", err);

    alert(
      "❌ Failed to update shop type.\n\n" +
      "Error: " +
      (err.code || "Unknown") +
      "\n\n" +
      (err.message || "")
    );

  } finally {
    setSavingShop(false);
  }
}

async function approveVolunteerSubmission(submission) {
  if (!submission?.id) return;

  if (
    !window.confirm(
      `Approve "${submission["Shop Name"]}"?\n\n₹10 will be credited to the volunteer.`
    )
  ) {
    return;
  }

  try {
    const submissionRef = doc(
      db,
      "businessSubmissions",
      submission.id
    );

    /*
     * Create the actual shop
     */
    const shopRef = await addDoc(
      collection(db, "shops"),
      {
        "Shop Name":
          submission["Shop Name"] || "",

        "Mobile Number":
          submission["Mobile Number"] || "",

        Location:
          submission.Location || "",

        Category:
          submission.Category || "",

        "Shop Image":
          submission["Shop Image"] || "",

        Description:
          submission.Description || "",

        OwnerName:
          submission.OwnerName || "",

        OpeningTime:
          submission.OpeningTime || "",

        ClosingTime:
          submission.ClosingTime || "",

        Instagram:
          submission.Instagram || "",

        Facebook:
          submission.Facebook || "",

        X:
          submission.X || "",

        Threads:
          submission.Threads || "",

        Youtube:
          submission.Youtube || "",

        Likes: 0,

        Shares: 0,

        LikedUsers: [],

        "Type (Premium/Normal)": "Normal",

        /*
         * Mark this as volunteer-added
         */
        addedByVolunteer: true,

        volunteerUid:
          submission.volunteerUid || "",

        volunteerName:
          submission.volunteerName ||
          "Community Volunteer",

        volunteerEmail:
          submission.volunteerEmail || "",

        /*
         * Verification information
         */
        VolunteerSelfie:
          submission.VolunteerSelfie || "",

        ShopFrontPhoto:
          submission.ShopFrontPhoto || "",

        /*
         * Shop metadata
         */
        productCount: 0,

        createdAt:
          serverTimestamp(),

        approvedAt:
          serverTimestamp(),

        submissionId:
          submission.id,
      }
    );

    /*
     * Mark submission as approved
     */
    await updateDoc(
      submissionRef,
      {
        status: "APPROVED",

        approved: true,

        rejected: false,

        approvedAt:
          serverTimestamp(),

        approvedBy:
          user?.uid || "",

        approvedShopId:
          shopRef.id,

        rewardPaid: true,

        rewardAmount: 10,
      }
    );

    /*
     * Credit ₹10 ONLY after approval
     */
    if (submission.volunteerUid) {
      await creditWallet(
        submission.volunteerUid,
        10,
        "Volunteer Business Approval",
        submission.id
      );
    }

    alert(
      "✅ Business approved successfully!\n\n" +
      "🏪 Business added to Shops.\n" +
      "💰 ₹10 credited to volunteer."
    );

  } catch (err) {
    console.error(
      "Volunteer approval failed:",
      err
    );

    alert(
      "Failed to approve volunteer submission."
    );
  }
}

async function rejectVolunteerSubmission(
  submission
) {
  if (!submission?.id) return;

  if (
    !window.confirm(
      `Reject "${submission["Shop Name"]}"?`
    )
  ) {
    return;
  }

  try {
    await updateDoc(
      doc(
        db,
        "businessSubmissions",
        submission.id
      ),
      {
        status: "REJECTED",

        approved: false,

        rejected: true,

        rejectedAt:
          serverTimestamp(),

        rejectedBy:
          user?.uid || "",

        rewardPaid: false,
      }
    );

    alert(
      "❌ Volunteer business submission rejected."
    );

  } catch (err) {
    console.error(
      "Volunteer rejection failed:",
      err
    );

    alert(
      "Failed to reject submission."
    );
  }
}

  async function approve(uid) {
    try {
      await updateDoc(doc(db, "autos", uid), {
        verified: true,
        updatedAt: serverTimestamp(),
      });

      alert("✅ Driver approved successfully.");
    } catch (err) {
      console.error(err);
      alert("Failed to approve driver.");
    }
  }

  async function reject(uid) {
    if (!window.confirm("Reject this application?")) return;

    try {
      await deleteDoc(doc(db, "autos", uid));
    } catch (err) {
      console.error(err);
      alert("Failed to reject application.");
    }
  }

  function toggleSection(section) {
    setActiveSection(
      activeSection === section ? null : section
    );
  }

  if (loading) {
    return (
      <div className="admin-loading">
        Loading Admin Dashboard...
      </div>
    );
  }

  if (!isAdmin) return null;

  return (
    <div className="admin-page">

      {/* HEADER */}
      <div className="admin-header">
        <div>
          <h2>Admin Dashboard</h2>
          <p>Manage Eyal App</p>
        </div>

        <div className="admin-header-icon">
          🛠️
        </div>
      </div>


      {/* ================= DRIVERS ================= */}
      <div className="admin-section">

        <div className="admin-section-title">
          🚗 DRIVERS
        </div>

        <div className="admin-menu-card">

          <AdminMenuItem
            icon={<FaCar />}
            iconClass="driver-icon"
            title="Pending Auto Drivers"
            subtitle="Review new driver applications"
            badge={drivers.length}
            onClick={() => toggleSection("drivers")}
            active={activeSection === "drivers"}
          />

          <AdminMenuItem
  icon={<FaUserCheck />}
  iconClass="approved-icon"
  title="Approved Drivers"
  subtitle="Manage verified auto drivers"
  badge={approvedDrivers.length}
  onClick={() => toggleSection("approvedDrivers")}
  active={activeSection === "approvedDrivers"}
/>

        </div>

      </div>


      {/* PENDING DRIVER CONTENT */}
      {activeSection === "drivers" && (
        <div className="admin-content-card">

          <div className="admin-content-header">
            <div>
              <h3>Pending Auto Drivers</h3>
              <p>{drivers.length} application(s) waiting</p>
            </div>
          </div>

          {drivers.length === 0 ? (
            <div className="admin-empty">
              <div className="admin-empty-icon">
                ✓
              </div>

              <h4>No pending applications</h4>

              <p>
                All auto driver applications have been reviewed.
              </p>
            </div>
          ) : (
            <div className="admin-driver-list">

              {drivers.map((driver) => (
                <div
                  key={driver.id}
                  className="admin-driver-card"
                >

                  <img
                    src={driver.photo}
                    alt=""
                    className="admin-photo"
                  />

                  <div className="admin-info">

                    <h4>{driver.driverName}</h4>

                    <p>
                      📱 {driver.mobile}
                    </p>

                    <p>
                      🚗 {driver.autoNumber}
                    </p>

                    <p>
                      📍 {driver.serviceArea}
                    </p>

                  </div>

                  <div className="admin-driver-actions">

                    <button
                      className="approve-btn"
                      onClick={() =>
                        approve(driver.id)
                      }
                    >
                      Approve
                    </button>

                    <button
                      className="reject-btn"
                      onClick={() =>
                        reject(driver.id)
                      }
                    >
                      Reject
                    </button>

                  </div>

                </div>
              ))}

            </div>
          )}

        </div>
      )}


{/* APPROVED DRIVER CONTENT */}
{activeSection === "approvedDrivers" && (
  <div className="admin-content-card">

    <div className="admin-content-header">
      <div>
        <h3>Approved Auto Drivers</h3>
        <p>
          {approvedDrivers.length} verified driver(s)
        </p>
      </div>
    </div>

    {approvedDrivers.length === 0 ? (
      <div className="admin-empty">

        <div className="admin-empty-icon">
          ✓
        </div>

        <h4>No approved drivers</h4>

        <p>
          No verified auto drivers found.
        </p>

      </div>
    ) : (
      <div className="admin-driver-list">

        {approvedDrivers.map((driver) => (
          <div
            key={driver.id}
            className="admin-driver-card"
          >

            <img
              src={driver.photo}
              alt=""
              className="admin-photo"
            />

            <div className="admin-info">

              <h4>
                {driver.driverName || "Unknown Driver"}
              </h4>

              <p>
                📱 {driver.mobile || "No mobile"}
              </p>

              <p>
                🚗 {driver.autoNumber || "No auto number"}
              </p>

              <p>
                📍 {driver.serviceArea || "Area not specified"}
              </p>

              <p>
                ⭐ Rating: {driver.rating ?? 0}
              </p>

            </div>

            <div className="admin-driver-status">

              <span className="approved-status">
                ✓ Approved
              </span>

              <span
                className={
                  driver.available
                    ? "available-status"
                    : "offline-status"
                }
              >
                {driver.available
                  ? "Available"
                  : "Unavailable"}
              </span>

            </div>

          </div>
        ))}

      </div>
    )}

  </div>
)}

{/* ================= DELIVERY PERSONS ================= */}

<div className="admin-section">

  <div className="admin-section-title">
    🚚 DELIVERY PERSONS
  </div>

  <div className="admin-menu-card">

    <AdminMenuItem
      icon={<FaBoxOpen />}
      iconClass="delivery-icon"
      title="Pending Applications"
      subtitle="Review delivery person applications"
      badge={deliveryPersons.length}
      onClick={() =>
        toggleSection("deliveryPersons")
      }
      active={
        activeSection === "deliveryPersons"
      }
    />

    <AdminMenuItem
      icon={<FaUserCheck />}
      iconClass="approved-icon"
      title="Approved Delivery Persons"
      subtitle="Manage verified delivery persons"
      badge={approvedDeliveryPersons.length}
      onClick={() =>
        toggleSection("approvedDeliveryPersons")
      }
      active={
        activeSection ===
        "approvedDeliveryPersons"
      }
    />

  </div>

</div>

{/* ================= PENDING DELIVERY PERSONS ================= */}

{activeSection === "deliveryPersons" && (
  <div className="admin-content-card">

    <div className="admin-content-header">
      <div>
        <h3>
          Pending Delivery Person Applications
        </h3>

        <p>
          {deliveryPersons.length} application(s) waiting
        </p>
      </div>
    </div>

    {deliveryPersons.length === 0 ? (

      <div className="admin-empty">

        <div className="admin-empty-icon">
          ✓
        </div>

        <h4>
          No pending applications
        </h4>

        <p>
          All delivery person applications
          have been reviewed.
        </p>

      </div>

    ) : (

      <div className="admin-driver-list">

        {deliveryPersons.map((person) => (

          <div
            key={person.id}
            className="admin-driver-card"
          >

            {/* PHOTO */}

            {person.photo ? (

              <img
                src={person.photo}
                alt=""
                className="admin-photo"
              />

            ) : (

              <div
                className="admin-photo"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 32,
                }}
              >
                🚚
              </div>

            )}


            {/* INFORMATION */}

            <div className="admin-info">

              <h4>
                {person.name ||
                  "Unknown Delivery Person"}
              </h4>

              <p>
                📱{" "}
                {person.mobile ||
                  "No mobile"}
              </p>

              <p>
                📍{" "}
                {person.area ||
                  "Area not specified"}
              </p>

              <p>
                🏠{" "}
                {person.address ||
                  "Address not specified"}
              </p>

              <p>
                🚚{" "}
                {person.vehicleType ||
                  "Vehicle not specified"}
              </p>

              <p>
                🔢{" "}
                {person.vehicleNumber ||
                  "Vehicle number not specified"}
              </p>

            </div>

{/* IDENTITY DOCUMENTS */}

<div className="admin-documents">

  <h5>🪪 Identity Documents</h5>

  <div className="admin-document-buttons">

    {person.drivingLicenseFront ? (
      <a
        href={person.drivingLicenseFront}
        target="_blank"
        rel="noopener noreferrer"
        className="document-view-btn"
      >
        🚗 Licence Front
      </a>
    ) : (
      <span className="document-missing">
        Licence Front Missing
      </span>
    )}

    {person.drivingLicenseBack ? (
      <a
        href={person.drivingLicenseBack}
        target="_blank"
        rel="noopener noreferrer"
        className="document-view-btn"
      >
        🚗 Licence Back
      </a>
    ) : (
      <span className="document-missing">
        Licence Back Missing
      </span>
    )}

    {person.aadhaarFront ? (
      <a
        href={person.aadhaarFront}
        target="_blank"
        rel="noopener noreferrer"
        className="document-view-btn"
      >
        🪪 Aadhaar Front
      </a>
    ) : (
      <span className="document-missing">
        Aadhaar Front Missing
      </span>
    )}

    {person.aadhaarBack ? (
      <a
        href={person.aadhaarBack}
        target="_blank"
        rel="noopener noreferrer"
        className="document-view-btn"
      >
        🪪 Aadhaar Back
      </a>
    ) : (
      <span className="document-missing">
        Aadhaar Back Missing
      </span>
    )}

  </div>

</div>
            {/* ACTIONS */}

            <div className="admin-driver-actions">

              <button
                className="approve-btn"
                onClick={() =>
                  approveDeliveryPerson(
                    person.id
                  )
                }
              >
                Approve
              </button>

              <button
                className="reject-btn"
                onClick={() =>
                  rejectDeliveryPerson(
                    person.id
                  )
                }
              >
                Reject
              </button>

            </div>

          </div>

        ))}

      </div>

    )}

  </div>
)}

{/* ================= APPROVED DELIVERY PERSONS ================= */}

{activeSection === "approvedDeliveryPersons" && (
  <div className="admin-content-card">

    <div className="admin-content-header">
      <div>

        <h3>
          Approved Delivery Persons
        </h3>

        <p>
          {approvedDeliveryPersons.length} verified delivery person(s)
        </p>

      </div>
    </div>


    {approvedDeliveryPersons.length === 0 ? (

      <div className="admin-empty">

        <div className="admin-empty-icon">
          🚚
        </div>

        <h4>
          No approved delivery persons
        </h4>

        <p>
          No verified delivery persons found.
        </p>

      </div>

    ) : (

      <div className="admin-driver-list">

        {approvedDeliveryPersons.map(
          (person) => (

            <div
              key={person.id}
              className="admin-driver-card"
            >

              {/* PHOTO */}

              {person.photo ? (

                <img
                  src={person.photo}
                  alt=""
                  className="admin-photo"
                />

              ) : (

                <div
                  className="admin-photo"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 32,
                  }}
                >
                  🚚
                </div>

              )}


              {/* INFORMATION */}

              <div className="admin-info">

                <h4>
                  {person.name ||
                    "Unknown Delivery Person"}
                </h4>

                <p>
                  📱{" "}
                  {person.mobile ||
                    "No mobile"}
                </p>

                <p>
                  📍{" "}
                  {person.area ||
                    "Area not specified"}
                </p>

                <p>
                  🚚{" "}
                  {person.vehicleType ||
                    "Vehicle not specified"}
                </p>

                <p>
                  🔢{" "}
                  {person.vehicleNumber ||
                    "No vehicle number"}
                </p>

                <p>
                  ⭐ Rating:{" "}
                  {person.rating ?? 0}
                </p>

                <p>
                  📦 Deliveries:{" "}
                  {person.totalDeliveries ?? 0}
                </p>

              </div>


              {/* STATUS */}

              <div className="admin-driver-status">

                <span className="approved-status">
                  ✓ Approved
                </span>

                <span
                  className={
                    person.available
                      ? "available-status"
                      : "offline-status"
                  }
                >
                  {person.available
                    ? "Available"
                    : "Unavailable"}
                </span>

              </div>

            </div>

          )
        )}

      </div>

    )}

  </div>
)}


      {/* ================= SHOPPING ================= */}
      <div className="admin-section">

        <div className="admin-section-title">
          🛒 SHOPPING
        </div>

        <div className="admin-menu-card">

          <AdminMenuItem
  icon={<FaStore />}
  iconClass="shop-icon"
  title="Manage Shops"
  subtitle="Manage Premium and Normal shops"
  badge={shops.length}
  onClick={() => toggleSection("shops")}
  active={activeSection === "shops"}
/>

<AdminMenuItem
  icon={<FaUserCheck />}
  iconClass="creator-icon"
  title="Volunteer Business Applications"
  subtitle="Review businesses submitted by volunteers"
  badge={volunteerSubmissions.length}
  onClick={() =>
    toggleSection("volunteerSubmissions")
  }
  active={
    activeSection === "volunteerSubmissions"
  }
/>

          <AdminMenuItem
            icon={<FaBoxOpen />}
            iconClass="product-icon"
            title="Manage Products"
            subtitle="Manage products listed in Eyal"
            onClick={() =>
              alert("Manage Products - coming soon")
            }
          />

          <AdminMenuItem
            icon={<FaShoppingCart />}
            iconClass="order-icon"
            title="Manage Orders"
            subtitle="View and manage shop orders"
            onClick={() =>
              alert("Manage Orders - coming soon")
            }
          />

        </div>

      </div>

{/* SHOP MANAGER */}
{activeSection === "shops" && (
  <div className="admin-content-card">

    <div className="admin-content-header">
      <div>
        <h3>Manage Shops</h3>
        <p>
          {shops.length} registered shop(s)
        </p>
      </div>
    </div>


    {/* SHOP FILTER */}
    <div className="shop-filter">

      <button
        className={
          shopFilter === "premium"
            ? "shop-filter-btn active"
            : "shop-filter-btn"
        }
        onClick={() => setShopFilter("premium")}
      >
        ⭐ Premium
        <span>
          {
            shops.filter(
              (shop) =>
                String(shop.shopType)
                  .toLowerCase()
                  .includes("premium")
            ).length
          }
        </span>
      </button>


      <button
        className={
          shopFilter === "normal"
            ? "shop-filter-btn active"
            : "shop-filter-btn"
        }
        onClick={() => setShopFilter("normal")}
      >
        🏪 Normal
        <span>
          {
            shops.filter(
              (shop) =>
                !String(shop.shopType)
                  .toLowerCase()
                  .includes("premium")
            ).length
          }
        </span>
      </button>

    </div>


    {/* SHOP LIST */}
    <div className="admin-shop-list">

      {shops
        .filter((shop) => {
          const isPremium = String(shop.shopType)
            .toLowerCase()
            .includes("premium");

          return shopFilter === "premium"
            ? isPremium
            : !isPremium;
        })
        .map((shop) => (

          <div
            key={shop.id}
            className="admin-shop-card"
          >

            {/* SHOP IMAGE */}
            {shop.shopImage ? (
              <img
                src={shop.shopImage}
                alt=""
                className="admin-shop-image"
              />
            ) : (
              <div className="admin-shop-image-placeholder">
                🏪
              </div>
            )}


            {/* SHOP INFO */}
            <div className="admin-shop-info">

              <div className="admin-shop-name-row">

                <h4>
                  {shop.shopName}
                </h4>

                {String(shop.shopType)
                  .toLowerCase()
                  .includes("premium") && (
                  <span className="premium-shop-badge">
                    PREMIUM
                  </span>
                )}

              </div>


              {shop.category && (
                <p>
                  🏷️ {shop.category}
                </p>
              )}

              {shop.location && (
                <p>
                  📍 {shop.location}
                </p>
              )}

              {shop.mobile && (
                <p>
                  📱 {shop.mobile}
                </p>
              )}

              <div className="admin-shop-stats">

                <span>
                  📦 {shop.productCount} products
                </span>

                <span>
                  👁️ {shop.shares} shares
                </span>

              </div>

            </div>


           <div className="admin-shop-actions">

  <button
    className="admin-shop-edit-btn"
    onClick={(e) => {
      e.stopPropagation();
      setEditingShop(shop);
    }}
  >
    <FaEdit />
    Edit
  </button>

  <FaChevronRight className="admin-shop-chevron" />

</div>

          </div>

        ))}


      {/* EMPTY */}
      {shops.filter((shop) => {
        const isPremium = String(shop.shopType)
          .toLowerCase()
          .includes("premium");

        return shopFilter === "premium"
          ? isPremium
          : !isPremium;
      }).length === 0 && (

        <div className="admin-empty">

          <div className="admin-empty-icon">
            🏪
          </div>

          <h4>
            No {shopFilter === "premium"
              ? "Premium"
              : "Normal"} shops
          </h4>

          <p>
            No shops found in this category.
          </p>

        </div>

      )}

    </div>

  </div>
)}

{/* ================= VOLUNTEER BUSINESS APPLICATIONS ================= */}

{activeSection === "volunteerSubmissions" && (
  <div className="admin-content-card">

    <div className="admin-content-header">
      <div>
        <h3>
          Volunteer Business Applications
        </h3>

        <p>
          {volunteerSubmissions.length} application(s) waiting for approval
        </p>
      </div>
    </div>

    {volunteerSubmissions.length === 0 ? (
      <div className="admin-empty">

        <div className="admin-empty-icon">
          ✓
        </div>

        <h4>
          No pending volunteer applications
        </h4>

        <p>
          All volunteer business submissions have been reviewed.
        </p>

      </div>
    ) : (

      <div className="admin-driver-list">

        {volunteerSubmissions.map(
          (submission) => (

            <div
              key={submission.id}
              className="admin-driver-card"
            >

              {/* BUSINESS IMAGE */}

              {submission["Shop Image"] ? (
                <img
                  src={
                    submission["Shop Image"]
                  }
                  alt=""
                  className="admin-photo"
                />
              ) : (
                <div
                  className="admin-photo"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 32,
                  }}
                >
                  🏪
                </div>
              )}

              {/* INFORMATION */}

              <div className="admin-info">

                <h4>
                  {
                    submission[
                      "Shop Name"
                    ]
                  }
                </h4>

                <p>
                  📱{" "}
                  {
                    submission[
                      "Mobile Number"
                    ]
                  }
                </p>

                <p>
                  📍{" "}
                  {
                    submission.Location ||
                    "Not specified"
                  }
                </p>

                <p>
                  🏷️{" "}
                  {
                    submission.Category ||
                    "Not specified"
                  }
                </p>

                {submission.OwnerName && (
                  <p>
                    👤 Owner:{" "}
                    {
                      submission.OwnerName
                    }
                  </p>
                )}

                {submission.Description && (
                  <p>
                    📝{" "}
                    {
                      submission.Description
                    }
                  </p>
                )}

                <p>
                  🤝 Volunteer:{" "}
                  {
                    submission.volunteerName ||
                    "Community Volunteer"
                  }
                </p>

                {submission.volunteerEmail && (
                  <p>
                    ✉️{" "}
                    {
                      submission.volunteerEmail
                    }
                  </p>
                )}

              </div>

              {/* ACTIONS */}

              <div className="admin-driver-actions">

                <button
                  className="approve-btn"
                  onClick={() =>
                    approveVolunteerSubmission(
                      submission
                    )
                  }
                >
                  Approve
                </button>

                <button
                  className="reject-btn"
                  onClick={() =>
                    rejectVolunteerSubmission(
                      submission
                    )
                  }
                >
                  Reject
                </button>

              </div>

            </div>

          )
        )}

      </div>

    )}

  </div>
)}

{/* ================= EDIT SHOP TYPE ================= */}

{editingShop && (
  <div className="admin-modal-overlay">

    <div className="admin-modal">

      <div className="admin-modal-header">

        <div>
          <h3>Edit Shop</h3>
          <p>
            {editingShop.shopName}
          </p>
        </div>

        <button
          className="admin-modal-close"
          onClick={() => setEditingShop(null)}
        >
          ×
        </button>

      </div>


      <div className="admin-modal-body">

        <label className="admin-modal-label">
          Shop Type
        </label>

        <div className="shop-type-options">

          <button
            type="button"
            className={
              String(editingShop.shopType)
                .toLowerCase()
                .includes("premium")
                ? "shop-type-option selected"
                : "shop-type-option"
            }
            onClick={() =>
              setEditingShop({
                ...editingShop,
                shopType: "Premium",
              })
            }
          >
            <span className="shop-type-icon">
              ⭐
            </span>

            <span>
              <strong>Premium</strong>
              <small>
                Premium shop
              </small>
            </span>

            {String(editingShop.shopType)
              .toLowerCase()
              .includes("premium") && (
              <span className="shop-type-check">
                ✓
              </span>
            )}
          </button>


          <button
            type="button"
            className={
              !String(editingShop.shopType)
                .toLowerCase()
                .includes("premium")
                ? "shop-type-option selected"
                : "shop-type-option"
            }
            onClick={() =>
              setEditingShop({
                ...editingShop,
                shopType: "Normal",
              })
            }
          >
            <span className="shop-type-icon">
              🏪
            </span>

            <span>
              <strong>Normal</strong>
              <small>
                Normal shop
              </small>
            </span>

            {!String(editingShop.shopType)
              .toLowerCase()
              .includes("premium") && (
              <span className="shop-type-check">
                ✓
              </span>
            )}
          </button>

        </div>

      </div>


      <div className="admin-modal-footer">

        <button
          className="admin-modal-cancel"
          onClick={() => setEditingShop(null)}
          disabled={savingShop}
        >
          Cancel
        </button>

        <button
          className="admin-modal-save"
          onClick={saveShopType}
          disabled={savingShop}
        >
          {savingShop ? "Saving..." : "Save Changes"}
        </button>

      </div>

    </div>

  </div>
)}

      {/* ================= CONTENT ================= */}
      <div className="admin-section">

        <div className="admin-section-title">
          📰 CONTENT
        </div>

        <div className="admin-menu-card">

          <AdminMenuItem
            icon={<FaNewspaper />}
            iconClass="post-icon"
            title="Manage Posts"
            subtitle="Review and manage user posts"
            onClick={() =>
              alert("Manage Posts - coming soon")
            }
          />

          <AdminMenuItem
            icon={<FaMapMarkerAlt />}
            iconClass="local-icon"
            title="Local Updates"
            subtitle="Manage local area updates"
            onClick={() =>
              alert("Local Updates - coming soon")
            }
          />

        </div>

      </div>


      {/* ================= USERS ================= */}
      <div className="admin-section">

        <div className="admin-section-title">
          👥 USERS
        </div>

        <div className="admin-menu-card">

          <AdminMenuItem
            icon={<FaUsers />}
            iconClass="users-icon"
            title="Manage Users"
            subtitle="View and manage Eyal users"
            onClick={() =>
              alert("Manage Users - coming soon")
            }
          />

          <AdminMenuItem
            icon={<FaClipboardList />}
            iconClass="creator-icon"
            title="Creator Applications"
            subtitle="Review creator program applications"
            onClick={() =>
              alert("Creator Applications - coming soon")
            }
          />

        </div>

      </div>


      {/* ================= REPORTS ================= */}
      <div className="admin-section">

        <div className="admin-section-title">
          📊 REPORTS
        </div>

        <div className="admin-menu-card">

          <AdminMenuItem
            icon={<FaChartBar />}
            iconClass="report-icon"
            title="Dashboard Reports"
            subtitle="View Eyal platform statistics"
            onClick={() =>
              alert("Reports - coming soon")
            }
          />

        </div>

      </div>

    </div>
  );
}


/* =========================================================
   ADMIN MENU ITEM
========================================================= */

function AdminMenuItem({
  icon,
  iconClass,
  title,
  subtitle,
  badge,
  onClick,
  active,
}) {
  return (
    <button
      className={`admin-menu-item ${
        active ? "admin-menu-item-active" : ""
      }`}
      onClick={onClick}
    >

      <div className={`admin-menu-icon ${iconClass}`}>
        {icon}
      </div>

      <div className="admin-menu-text">

        <div className="admin-menu-title">
          {title}
        </div>

        <div className="admin-menu-subtitle">
          {subtitle}
        </div>

      </div>

      {badge !== undefined && badge > 0 && (
        <span className="admin-badge">
          {badge}
        </span>
      )}

      <FaChevronRight
        className={`admin-chevron ${
          active ? "admin-chevron-active" : ""
        }`}
      />

    </button>
  );
}